<template>
    <v-tab-item :value="CEMS.value">
        <v-container>
            <top-image :tit="CEMS.text" bgImage="/images/sub/product/cems-bg.jpg" image="/images/sub/product/cems-img.png">
                <p class="page-text mb-6 mb-lg-20">
                    케이아이이 시스템즈는 지구의 환경을 건강하게 유지하기 위해 유해물질 대기 배출량 및 대기질 모니터링의 중요성을 이해합니다. CEMS(Continuous Emission Monitoring Systems) 및 AQMS(Air Quality Monitoring Systems)에 대한 신뢰성이 높고 효율적인 종합 솔루션을 개발합니다.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    케이아이이 시스템즈는 모든 산업 분야에서 발생하는 대기 방출량과 대기질을 실시간으로 모니터링하고 측정할 수 있도록 솔루션을 제공합니다. 최신 기술을 적극 활용하여 고객에게 정확하고 신뢰성 높은 데이터를 제공하며, 항상 고객 중심의 접근 방식으로 요구를 충족시키기 위해 노력합니다. 케이아이이 시스템즈와 함께 하면 더 건강하고 안전한 환경을 만들어갈 수 있습니다.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    CEMS/AQMS는 광범위한 오염물질과 가스를 감지하고 측정할 수 있는 분석기, 샘플링 시스템, 센서와 같은 다양한 모니터링 장비를 포함하고 있습니다.
                </p>
                <p class="page-text">
                    케이아이이 시스템즈의 솔루션은 대기 방출량을 모니터링하고 측정하는 것 외에도, 데이터 분석 및 보고 시스템을 포함하고 있습니다. 고객은 수집된 데이터에 쉽게 접근하고 해석할 수 있습니다. 고객이 빠르게 개선이 필요한 영역을 파악하고 대기 방출량을 줄이고 대기 질을 개선하기 위한 조치를 취할 수 있도록 도와줍니다.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Ko_Product_TABS } from "@/assets/variables";
const { CEMS } = Ko_Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            CEMS,
        };
    },
};
</script>

<style scoped></style>
